export const STATUS_VARIANT = {
    ACTIVE: "success",
    INACTIVE: "muted",
    ARCHIVED: "warning",
} as const;

export const STATUS_LABEL = {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    ARCHIVED: "Archived",
} as const;
